import { Link } from "react-router-dom";
import { MartzmakesWordmarkLink } from "./MartzmakesWordmark";

/**
 * Site-wide footer — every page renders this for consistency. Carries the
 * domain string, beta badge, legal links, and the martzmakes wordmark
 * (blinking-cursor link to martzmakes.com).
 */
export function SiteFooter() {
  return (
    <footer className="px-6 py-5 border-t border-bg-2 flex items-center gap-3 text-fg-2 text-xs flex-wrap">
      <code className="font-mono text-fg-2/80">mcpbuild.app</code>
      <span className="text-fg-2/50">·</span>
      <span className="px-1.5 py-0.5 rounded bg-accent/15 text-accent text-[10px] uppercase tracking-wider">
        Beta
      </span>
      <span className="text-fg-2/50">·</span>
      <Link to="/privacy" className="hover:text-fg-0">
        Privacy
      </Link>
      <span className="text-fg-2/50">·</span>
      <Link to="/terms" className="hover:text-fg-0">
        Terms
      </Link>
      <span className="ml-auto inline-flex items-center gap-1.5 text-fg-2/80">
        <span>built by</span>
        <MartzmakesWordmarkLink size={12} />
      </span>
    </footer>
  );
}
